import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

type Props = {
  isExpanded: boolean;
  onToggle: () => void;
};

export default function BudgetSectionHeader({ isExpanded, onToggle }: Props) {
  return (
    <button
      type="button"
      onClick={onToggle}
      className="w-full flex items-center gap-6 px-5 py-5 text-left hover:bg-clear-dust transition-colors"
    >
      <div className="w-11 h-11 rounded-lg bg-light-dust flex items-center justify-center shrink-0">
        <CardGiftcardIcon sx={{ fontSize: 36, color: "var(--color-rodeo-black)" }} />
      </div>
      <div className="flex-1">
        <p className="font-crimson text-[18px] text-rodeo-black leading-none">
          Budget per recipient
        </p>
        <p className="font-lato text-[12px] text-graphite mt-0.5">Shipping and tax included</p>
      </div>
      <ExpandMoreIcon
        sx={{
          fontSize: 24,
          color: "var(--color-rodeo-black)",
          transition: "transform 0.2s",
          transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)",
        }}
      />
    </button>
  );
}
